import {graphql, useLazyLoadQuery} from 'react-relay'

import type {ProjectId} from '../../../../types'

import type {usePipelineParentProjectIdQuery} from './__generated__/usePipelineParentProjectIdQuery.graphql'
import {usePipelineId} from './pipeline'

const query = graphql`
  query usePipelineParentProjectIdQuery($pipelineLocator: String!) {
    pipeline(pipelineLocator: $pipelineLocator) {
      parentProject {
        id
      }
    }
  }
`

function usePipelineParentProjectId(): ProjectId | undefined {
  const pipelineId = usePipelineId()
  const {pipeline} = useLazyLoadQuery<usePipelineParentProjectIdQuery>(query, {
    pipelineLocator: `id:${pipelineId}`,
  })
  return pipeline?.parentProject?.id ?? undefined
}

export default usePipelineParentProjectId
